<template>
  <div>
    <div v-if="!loadStatus">
      <Loader />
    </div>
    <template v-if="loadStatus">
      <div class="date-banner" v-if="Object.keys(currentSubscription).length">
        <div class="date-banner-header">
          <img src="../../assets/course.svg" class="w-4.5" />
          <p>Subscription details</p>
        </div>

        <!-- {{ currentSubscription }} -->
        <section class="date-banner-content">
          <div class="date-banner-content-item">
            <p>Current plan:</p>
            <p>
              <strong>
                {{
                  plans.find((plan) => plan.id === currentSubscription.id).name
                }}
              </strong>
            </p>
          </div>
          <div class="date-banner-content-item">
            <p>Next billing date:</p>
            <p>
              <strong>
                {{ parseDate }}
              </strong>
              (Your payment method will be automatically charged
              <strong>
                ${{
                  plans.find((plan) => plan.id === currentSubscription.id)
                    .dollarAmount | formatCurrency
                }}</strong
              ><span>)</span>
            </p>
          </div>
          <!--    Backend Not Pushed      -->
          <!--          <div class="date-banner-content-item">-->
          <!--            <p>Sends available:</p>-->
          <!--            <p>-->
          <!--              <strong>-->
          <!--                {{-->
          <!--                  availableAdditionalOrders-->
          <!--                }}-->
          <!--              </strong>-->
          <!--              <strong class="buy-gift-sends" @click="showModal = true">-->
          <!--                Add sends-->
          <!--              </strong>-->
          <!--            </p>-->
          <!--          </div>-->
          <!--    Backend Not Pushed      -->
        </section>
      </div>
      <div v-else class="no-subscription-banner">
        <p>Choose a plan that’s right for you</p>
      </div>
      <BuyGiftSendsModal
        v-if="showModal"
        :showModal="showModal"
        @onCloseModal="showModal = false"
      />

      <!-- Plan section -->
      <section class="flex">
        <!-- Headlines here -->
        <!-- <div class="headlines">
          <p v-for="headline in headlines" :key="headline">{{ headline }}</p>
        </div> -->

        <!-- Plans Here -->
        <div class="flex flex-nowrap gap-3 horizontal-scroll">
          <div class="plan-holder" v-for="(plan, index) in plans" :key="index">
            <!-- Plan name -->
            <div class="plan-recomemded" v-if="plan.id === 2">
              <p>Recommended</p>
            </div>
            <div class="plan-name-holder">
              <p class="plan-name">{{ plan.name }}</p>
              <p class="plan-details-holder-price">
                ${{ plan.dollarAmount }}/mon
              </p>
            </div>

            <!-- Plan details -->
            <section
              class="plan-details-container"
              v-if="plan.name !== 'Custom'"
            >
              <div class="plan-details-holder">
                <p>
                  <img src="../../assets/gift.svg" alt="check" class="w-4" />
                  <strong>Standard</strong> Packaging
                </p>

                <p>
                  <img
                    src="../../assets/delivery.svg"
                    alt="check"
                    class="w-4"
                  />

                  Up to
                  <strong
                    >{{ plan.ordersLimit | formatNumber }} sends /{{
                      plan.interval
                    }}</strong
                  >
                </p>
                <p>
                  <img
                    src="../../assets/warehouse.svg"
                    alt="check"
                    class="w-4"
                  />
                  Up to
                  <strong
                    >{{ plan.whareHouseLimit | formatNumber }} items</strong
                  >
                </p>
                <p>
                  <img src="../../assets/users.svg" alt="check" class="w-4" />

                  <strong>{{ plan.usersLimit | formatNumber}}</strong> users
                </p>
                <p>
                  <img
                    src="../../assets/shipping.svg"
                    alt="check"
                    class="w-4"
                  />
                  <strong>{{
                    plan.internationalShipment ? 'International' : 'Domestic'
                  }}</strong>
                  shipping
                </p>
                <p>
                  <img
                    src="../../assets/credit-card.svg"
                    alt="check"
                    class="w-4"
                  />

                  Credit card payments
                </p>
              </div>

              <!-- Buttons here -->
              <div
                v-if="!Object.keys(currentSubscription).length"
                class="flex justify-center"
              >
                <button
                  id="subscribe-to-plan"
                  class="button-gemnote button-gemnote--small"
                  @click="subscribeToPlan(plan.id)"
                >
                  <span>Select plan</span>
                </button>
              </div>

              <div v-else class="flex justify-center">
                <template v-if="plan.id === currentSubscription.id">
                  <button
                    class="button-gemnote button-gemnote--small button-gemnote--disabled current-plan"
                  >
                    <span>Current plan</span>
                  </button>
                </template>

                <template v-else>
                  <button
                    id="update-plan-btn"
                    class="whitebutton-gemnote whitebutton-gemnote--small"
                    :ref="`UpdatePlan${index}ButtonRef`"
                    @click="
                      updateYourPlan(plan.id, `UpdatePlan${index}ButtonRef`)
                    "
                  >
                    <span>{{ generateLabel(index) }}</span>
                  </button>
                </template>
              </div>
            </section>
            <section class="plan-details-container" v-else>
              <div class="plan-details-holder">
                <p>Custom plan to meet your specific needs</p>

                <p>
                  <img src="../../assets/star.svg" alt="check" class="w-4" />

                  Special offers
                </p>
              </div>

              <!-- Buttons here -->
              <button class="contact-support-btn">
                Contact Customer Support
              </button>
            </section>
          </div>
        </div>
      </section>
      <!-- plans footer -->
      <div class="plans-footer">
        <div class="footer-item">
          <strong>All plans include</strong>
          <div class="items">
            <div class="flex items-center gap-2 item flex-wrap md:flex-nowrap">
              <img
                src="../../assets/circle-check.svg"
                alt="check"
                class="w-6"
              />
              <span>Dedicated customer support</span>
            </div>
            <div class="flex items-center gap-2 item">
              <img
                src="../../assets/circle-check.svg"
                alt="check"
                class="w-6"
              />
              <span>Pick and pack</span>
            </div>
            <div class="flex items-center gap-2 item">
              <img
                src="../../assets/circle-check.svg"
                alt="check"
                class="w-6"
              />
              <span>Custom kitting</span>
            </div>
            <div class="flex items-center gap-2 item">
              <img
                src="../../assets/circle-check.svg"
                alt="check"
                class="w-6"
              />
              <span>Store and ship</span>
            </div>
          </div>
        </div>
        <div class="footer-item payment-methods">
          <strong>Accepted payment methods</strong>
          <div class="items payment-methods">
            <div class="flex items-center gap-2 item flex-wrap md:flex-nowrap">
              <img src="../../assets/visa-pill.svg" alt="check" class="" />
            </div>
            <div class="flex items-center gap-2 item">
              <img
                src="../../assets/mastercard-pill.svg"
                alt="check"
                class=""
              />
            </div>
            <div class="flex items-center gap-2 item">
              <img
                src="../../assets/am-express-pill.svg"
                alt="check"
                class=""
              />
            </div>
            <div class="flex items-center gap-2 item">
              <img src="../../assets/discover-pill.svg" alt="check" class="" />
            </div>
            <div class="flex items-center gap-2 item">
              <img src="../../assets/guard.svg" alt="check" class="w-4" />
              <span>SSL Secure Encryption</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { progressStatus } from '../../helpers'

export default {
  name: 'SubscriptionsTable',
  props: {
    paymentTab: {
      type: Object,
      required: true,
    },
  },

  created() {
    if (!this.paymentMethods.length) {
      this.$store.dispatch('billing/getPaymentMethods')
    }
    this.$store.dispatch('billing/getPlans')
  },

  data: () => ({
    headlines: [
      'Monthly Cost',
      'Packaging',
      'Monthly Sends',
      'Warehousing',
      'Users',
      'Shipping',
      'Payment',
    ],
    showModal: false,
  }),

  computed: {
    columnWidth() {
      return {
        width: this.plans.length <= 3 ? '25%' : '19%',
      }
    },
    loadStatus() {
      return progressStatus(this.loadPlans)
    },
    ...mapState({
      loadPlans: (state) => state.billing.loadPlans,
      paymentMethods: (state) => state.billing.paymentMethods,
      plans: (state) =>
        state.billing.plans.sort(
          (a, b) => parseInt(a.dollarAmount) - parseInt(b.dollarAmount)
        ),
      currentSubscription: (state) => state.billing.currentSubscription,
      updatingCurrentSubscription: (state) =>
        state.billing.updatingCurrentSubscription,
      availableAdditionalOrders: (state) =>
        state.team.team.availableAdditionalOrders,
    }),

    parseDate() {
      return `${moment(this.currentSubscription.currentPeriodEnd).format(
        'MMMM DD, YYYY'
      )} at ${moment(this.currentSubscription.currentPeriodEnd).format(
        'h:mmA'
      )} PST`
    },
  },

  components: {
    Loader: () => import('./SubscriptionTableLoader.vue'),
    BuyGiftSendsModal: () => import('./BuyGiftSendsModal'),
  },

  methods: {
    borderRigthClass(index) {
      return index !== this.plans.length - 1 ? 'border__right' : ''
    },
    subscribeToPlan(planId) {
      this.$store
        .dispatch('billing/validatesSubscriptionRequirements', planId)
        .then(() => {
          this.$store.dispatch('billing/subscribeToPlan', planId)
        })
        .catch((error) => {
          if (error.message === 'no_payment_method') {
            this.$emit('subscribed', this.paymentTab)
          }
        })
    },
    generateLabel(index) {
      return index < this.currentSubscription.index
        ? 'Downgrade plan'
        : 'Upgrade plan'
    },
    async updateYourPlan(planId, buttonRref) {
      const updatePlanBtn = this.$refs[buttonRref]
      updatePlanBtn[0].classList.add('disabled')
      updatePlanBtn[0].disabled = true
      await this.$store.dispatch('billing/updatePlan', planId)
      updatePlanBtn[0].classList.remove('disabled')
      updatePlanBtn[0].disabled = false
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.horizontal-scroll {
  overflow-y: hidden;
}

.date-banner {
  margin-bottom: 2.5rem;
  height: max-content;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  background: #dfdad2;
  border-radius: 12px;

  h5 {
    font-weight: normal;
    font-family: $inter;
    color: $onyx;
    font-size: 0.875rem;
    text-align: left;
  }

  .date-banner-header {
    display: flex;
    align-items: center;
    gap: 0.2rem;

    p {
      font-size: 0.823rem;
      font-weight: 700;
      color: #000000;
    }
  }

  .date-banner-content {
    margin-top: 0.9rem;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;

    .date-banner-content-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      flex-wrap: wrap;

      p {
        font-size: 0.823rem;
        font-weight: 400;
        color: #000000;
        text-align: left;
      }

      strong {
        font-weight: 700;
        color: #514d43;

        &.buy-gift-sends {
          color: #25282a;
          font-weight: 700;
          font-family: $inter;
          font-size: 0.875rem;
          cursor: pointer;
          margin-left: 5px;
          border-bottom: 1px solid #25282a;
        }
      }
    }
  }
}

.no-subscription-banner {
  margin-bottom: 2.5rem;
  display: flex;
  flex-direction: column;

  p {
    font-size: 0.913rem;
    font-weight: 600;
    color: #000000;
    text-align: left;
  }
}

section {
  .headlines {
    width: 22%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 20px;

    p {
      text-align: left;
      font-size: 0.875rem;
      color: #25282a;
      font-weight: 700;
      font-family: $inter;
    }
  }

  .plan-holder {
    border: 1px solid #24292c;
    border-radius: 0px;
    height: 500px;
    min-width: 250px;
    width: 250px;
    padding-top: 1.75rem;
    position: relative;

    display: flex;
    flex-direction: column;
    // justify-content: space-between;

    .plan-name-holder {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      align-items: center;
      margin: 1.75rem;
      margin-bottom: 0.75rem;
    }

    .plan-name {
      font-family: $editorial;
      font-size: 1.7rem;
      font-weight: normal;
      text-transform: capitalize;
    }

    .plan-details-holder-price {
      font-weight: 700;
      color: #232220;
      text-align: center;
      font-size: 0.913rem;
    }

    .plan-details-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 2rem;
    }

    .plan-details-holder {
      margin: 0px auto;
      width: 85%;
      border-top: 1px solid #a09c95;
      padding-top: 1.75rem;

      p {
        display: flex;
        align-items: center;
        gap: 0.4rem;
        text-align: left;
        font-size: 0.815rem;
        padding-bottom: 0.8rem;
      }
    }

    .button-gemnote--small,
    .whitebutton-gemnote--small {
      height: 2.5rem;
      font-size: 0.813rem;
      width: auto;
      padding: 0 1.25rem;

      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
        color: #232220;
      }

      &.current-plan {
        background: #dfdad2;
        color: #514d43;
      }
    }

    .button-gemnote--disabled {
      background: #514d43;
    }

    .plan-recomemded {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: #fba04c;
      padding: 0.5rem;
      text-transform: uppercase;

      p {
        font-size: 0.713rem;
        color: #232220;
        font-weight: 500;
      }
    }
  }

  .contact-support-btn {
    color: #25282a;
    font-size: 0.813rem;
    font-weight: 700;
    background: transparent;
    border-bottom: 1px solid #25282a;
    width: max-content;
    margin: 0 auto;
    cursor: pointer;
  }
}

.plans-footer {
  margin-top: 2.5rem;
  border-top: 1px solid #a09c95;
  padding-top: 1.5rem;

  .footer-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #a09c95;
    padding-bottom: 1.5rem;
    margin-bottom: 1.5rem;
    font-size: 0.813rem;
    color: #25282a;
    gap: 2rem;
    padding-right: 10px;
    padding-left: 10px;

    &.payment-methods {
      gap: 2rem;
      justify-content: flex-start;
    }

    .items {
      display: flex;
      gap: 2rem;

      &.payment-methods {
        gap: 1rem;
      }

      .item {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        span {
          font-size: 0.813rem;
          color: #514d43;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .footer-item {
    flex-direction: column;

    .items {
      flex-wrap: wrap;
    }
  }
}
</style>
